// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — img.classic.js, новая — img.cp.js
import { isCp } from 'libs/design';
import * as classic from './img.classic';
import * as cp from './img.cp';

export const Img = isCp ? cp.Img : classic.Img;
